import {Collapse, Tag, Empty} from "antd";
import className from "classnames/bind";
import style from "../style/SiteCrawler.module.scss";

const cn = className.bind(style);

const SEVERITY = [
	{key: 'error', label: 'Lỗi nặng', color: 'red'},
	{key: 'warning', label: 'Cảnh báo', color: 'orange'},
	{key: 'info', label: 'Thông tin', color: 'blue'},
];

/** Một issue cấp site kèm URL trang liên quan (nếu có) + danh sách URL trong meta. */
function IssueRow({issue, onOpenPage}) {

	const urls = issue.meta && Array.isArray(issue.meta.urls) ? issue.meta.urls : null;

	return (
		<div className={cn('issueItem')}>
			<div>{issue.message}</div>

			{issue.url && (
				<div className={cn('issueMeta')}>
					<span className={cn('issueLink')} onClick={() => issue.page_id && onOpenPage?.(issue.page_id)}>
						{issue.url}
					</span>
				</div>
			)}

			{urls && <div className={cn('issueMeta')}>{urls.join('\n')}</div>}
		</div>
	);
}

/**
 * Báo cáo Tầng B — vấn đề CẤP SITE (duplicate, broken link, orphan, redirect, server
 * error...). Issue theo từng trang (type `page_*`) được tách sang PageIssueList.
 */
function IssueSection({issues, onOpenPage}) {

	if (!issues) return null;

	const total = SEVERITY.reduce((s, sv) => s + (issues[sv.key]?.length || 0), 0);

	if (total === 0) {
		return <Empty description="Không phát hiện vấn đề cấp site nào 🎉" />;
	}

	const items = SEVERITY
		.filter((sv) => (issues[sv.key]?.length || 0) > 0)
		.map((sv) => ({
			key: sv.key,
			label: (
				<span>
					<Tag color={sv.color}>{sv.label}</Tag>
					<strong>{issues[sv.key].length}</strong> mục
				</span>
			),
			children: (
				<div>
					{issues[sv.key].map((iss) => (
						<IssueRow key={iss.id} issue={iss} onOpenPage={onOpenPage} />
					))}
				</div>
			),
		}));

	return <Collapse items={items} defaultActiveKey={['error', 'warning']} />;
}

export default IssueSection;
